import React, { useState, useEffect, Fragment } from "react";
import {
  Typography,
  Space,
  Checkbox,
  Select,
  Spin,
  notification,
  InputNumber,
  Modal,
  Form,
  Input,
  Radio,
} from "antd";
import moment from "moment";
import MessageService from "services/messageService";
import StationMessageConfigsService from "services/StationMessageConfigsService";
import { useTranslation } from "react-i18next";
import "./customerSettings.scss";
import { useSelector } from "react-redux";
import UnLock from "components/UnLock/UnLock";
import BasicButtonPrimary from "components/BasicButtonPrimary";
import { useHistory } from "react-router-dom";
import { BackButton } from "components/PopupHeader/PopupHeader";

const { Title } = Typography;
const { Option } = Select;
const SETTING_STATUS = {
  ENABLE: 1,
  DISABLE: 0,
};

const CustomerCreateSetting = () => {
  const { t: translation } = useTranslation();
  const history = useHistory();
  const [selectedTime, setSelectedTime] = useState(null);
  const [isHaveSelectedTime, setIsHaveSelectedTime] = useState(false);
  const handleChangeSendTime = (value) => {
    setSelectedTime(value);

    if (value === "other") {
      // Reset các field khác về 0
      const newSettings = { ...settings };
      data.forEach((item) => {
        newSettings[item.settingField] = 0;
      });

      // Giữ lại enableAutoSentNotiBeforeOtherDays hiện tại (hoặc gán mặc định)
      if (!newSettings.enableAutoSentNotiBeforeOtherDays) {
        newSettings.enableAutoSentNotiBeforeOtherDays = 1;
      }

      setSettings(newSettings);
    } else {
      // Reset input "other" về 0, bật chỉ field được chọn
      const newSettings = { ...settings };
      newSettings.enableAutoSentNotiBeforeOtherDays = 0;

      data.forEach((item) => {
        newSettings[item.settingField] = item.settingField === value ? 1 : 0;
      });

      setSettings(newSettings);
    }
  };

  const [settings, setSettings] = useState({
    enableAutoSentNotiBefore30Days: SETTING_STATUS.DISABLE,
    enableAutoSentNotiBefore15Days: SETTING_STATUS.DISABLE,
    enableAutoSentNotiBefore7Days: SETTING_STATUS.DISABLE,
    enableAutoSentNotiBefore3Days: SETTING_STATUS.DISABLE,
    enableAutoSentNotiBefore1Days: SETTING_STATUS.DISABLE,
    enableAutoSentNotiBeforeOtherDays: 0,
    enableNotiByAPNS: SETTING_STATUS.DISABLE,
    enableNotiBySmsCSKH: SETTING_STATUS.DISABLE,
    enableNotiByZaloCSKH: SETTING_STATUS.DISABLE,
    enableNotiBySMSRetry: SETTING_STATUS.DISABLE,
    enableNotiByAutoCall: SETTING_STATUS.DISABLE,
    messageTemplateAPNS: null,
    messageTemplateSmsCSKH: null,
    messageTemplateZaloCSKH: null,
    messageTemplateSMSRetry: null,
    messageTemplateAutoCall: null,
  });

  const [filter, setFilter] = useState({
    limit: 100,
  });
  const [temps, setTemps] = useState([]);
  const [isShowModal, setIsShowModal] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const days = [
    settings.enableAutoSentNotiBefore30Days,
    settings.enableAutoSentNotiBefore15Days,
    settings.enableAutoSentNotiBefore7Days,
    settings.enableAutoSentNotiBefore3Days,
    settings.enableAutoSentNotiBefore1Days,
    settings.enableAutoSentNotiBeforeOtherDays,
  ];
  const setting = useSelector((state) => state.setting);
  const handleCheckboxChange = (field) => {
    if (field === "enableNotiByZaloCSKH") {
      setSettings((prevSettings) => ({
        ...prevSettings,
        enableNotiBySMSRetry:
          prevSettings[field] === SETTING_STATUS.ENABLE
            ? SETTING_STATUS.DISABLE
            : SETTING_STATUS.ENABLE,
        [field]:
          prevSettings[field] === SETTING_STATUS.ENABLE
            ? SETTING_STATUS.DISABLE
            : SETTING_STATUS.ENABLE,
      }));
      return;
    }

    setSettings((prevSettings) => ({
      ...prevSettings,
      [field]:
        prevSettings[field] === SETTING_STATUS.ENABLE
          ? SETTING_STATUS.DISABLE
          : SETTING_STATUS.ENABLE,
    }));
  };

  useEffect(() => {
    MessageService.getMessageSMSTemplate(filter).then((result) => {
      if (result && result?.templates?.length > 0) {
        setTemps(result.templates);
        return;
      }
      setLoading(false);
      setTemps([]);
    });
  }, []);

  const handleChangeTemplate = (value, type) => {
    setSettings((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  const handleCheckRequiredFieldSelected = (data) => {
    if (data?.configTemplateName.trim() === "") {
      notification["error"]({
        message: "",
        description: translation(
          "settingAccreditation.configTemplateNameRequired"
        ),
      });
      return false;
    }
    const requiredFields = [
      "enableAutoSentNotiBefore30Days",
      "enableAutoSentNotiBefore15Days",
      "enableAutoSentNotiBefore7Days",
      "enableAutoSentNotiBefore3Days",
      "enableAutoSentNotiBefore1Days",
      "enableAutoSentNotiBeforeOtherDays",
    ];
    const isAnyFieldSelected = requiredFields.some(
      (field) => data[field] && data[field] !== SETTING_STATUS.DISABLE
    );
    if (!isAnyFieldSelected) {
      notification["error"]({
        message: "",
        description: translation("customerSettings.sendTimeRequired"),
      });
      return false;
    }

    if(isAnyFieldSelected && data.enableAutoNotiSchedule ===1) {
      return true
    }

    const notificationFields = [
      "enableNotiByAPNS",
      "enableNotiBySmsCSKH",
      "enableNotiByZaloCSKH",
      "enableNotiBySMSRetry",
      "enableNotiByAutoCall",
    ];
    const isAnyNotificationSelected = notificationFields.some(
      (field) => data[field] === SETTING_STATUS.ENABLE
    );
    if (!isAnyNotificationSelected) {
      notification["error"]({
        message: "",
        description: translation("customerSettings.notificationTypeRequired"),
      });
      return false;
    }

    const isAnyTemplateSelected = [
      data.messageTemplateAPNS,
      data.messageTemplateSmsCSKH,
      data.messageTemplateZaloCSKH,
      data.messageTemplateSMSRetry,
      data.messageTemplateAutoCall,
    ].some((template) => template !== null);
    if (!isAnyTemplateSelected) {
      notification["error"]({
        message: "",
        description: translation("customerSettings.templateMessageRequired"),
      });
      return false;
    }
    return true;
  };

  const onFinish = (values) => {
    values.enableAutoNotiSchedule = values.enableAutoNotiSchedule ? 1 : 0;
    const data = Object.assign({}, settings, values, { enableConfig: 1 });
    if (!handleCheckRequiredFieldSelected(data)) return;
    StationMessageConfigsService.advanceUserCreateStationMessageConfigs(
      data
    ).then((res) => {
      if (res.isSuccess) {
        notification["success"]({
          message: "",
          description: translation("customerSettings.saveSuccess"),
        });
        setIsShowModal(false);
        window.history.go(-1);
        return;
      }
      notification["error"]({
        message: "",
        description: res?.error || translation("customerSettings.saveFailed"),
      });
    });
  };

  const handleDaysInputChange = (value) => {
    setSettings((prev) => ({
      ...prev,
      enableAutoSentNotiBeforeOtherDays: value,
    }));
  };

  const data = [
    {
      time: "timeBefore30Days",
      notification: "notificationApp",
      settingField: "enableAutoSentNotiBefore30Days",
      notiField: "enableNotiByAPNS",
      type: "messageTemplateAPNS",
      messageTemplateType: "APNS",
    },
    {
      time: "timeBefore15Days",
      notification: "notificationSMS",
      settingField: "enableAutoSentNotiBefore15Days",
      notiField: "enableNotiBySmsCSKH",
      type: "messageTemplateSmsCSKH",
      messageTemplateType: "SMS_CSKH",
    },
    {
      time: "timeBefore7Days",
      notification: "notificationZalo",
      settingField: "enableAutoSentNotiBefore7Days",
      notiField: "enableNotiByZaloCSKH",
      type: "messageTemplateZaloCSKH",
      messageTemplateType: "ZALO_CSKH",
    },
    {
      time: "timeBefore3Days",
      notification: "notificationSMSIfNoZalo",
      settingField: "enableAutoSentNotiBefore3Days",
      notiField: "enableNotiBySMSRetry",
      type: "messageTemplateSMSRetry",
      messageTemplateType: "SMS_CSKH",
    },
    {
      time: "timeBefore1Day",
      notification: "autoCall",
      settingField: "enableAutoSentNotiBefore1Days",
      notiField: "enableNotiByAutoCall",
      type: "messageTemplateAutoCall",
      messageTemplateType: "CALL",
    },
  ];

  return (
    <Fragment>
      {setting.enableCustomerMenu === 0 ? (
        <UnLock />
      ) : (
        <div>
          <div className="d-flex gap-2">
            <div style={{ width: "max-content" }}>
              <BackButton visible={true} actionUrl="/list-customers" />
            </div>
            <Title level={3} className="section-title">
              {translation("customerSettings.autoSendNotificationTitle")}
            </Title>
          </div>
          {isLoading ? (
            <Spin />
          ) : (
            <Space direction="vertical" size="large" style={{ width: "100%" }}>
              <div className="row">
                <div className="col-md-4 col-12 text-center">
                  <div className="col-12 d-flex mb-2">
                    {translation("customerSettings.configTemplateName")}
                  </div>
                  <Form
                    form={form}
                    name="confirmConfigTemplateName"
                    autoComplete="off"
                    onFinish={onFinish}
                    size="small"
                    colon={false}
                    labelAlign="right"
                  >
                    <Form.Item
                      className="w-100"
                      name="configTemplateName"
                      rules={[
                        {
                          required: true,
                          message: (
                            <div
                              style={{ textAlign: "left" }}
                              className="text-left text-danger"
                            >
                              {translation(
                                "settingAccreditation.configTemplateNameRequired"
                              )}
                            </div>
                          ),
                        },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Form>
                </div>
              </div>
              <div className="row">
                <div className="d-md-flex d-none col-md-4 col-0">
                  {translation("customerSettings.sendTime")}
                </div>
                <div className="d-md-flex d-none col-md-4 col-0">
                  {translation("customerSettings.notificationType")}
                </div>
              </div>
              <div className="row">
                <div className="col-md-4 col-12">
                  <div className="d-md-none col-12 d-flex mb-2">
                    {translation("customerSettings.sendTime")}
                  </div>
                  <Radio.Group
                    value={selectedTime}
                    onChange={(e) => {
                      handleChangeSendTime(e.target.value);
                      setIsHaveSelectedTime(true);
                    }}
                  >
                    {data.map((item) => (
                      <div className="row" key={item.settingField}>
                        <div className="col-12 mb-4" style={{ height: 32 }}>
                          <Radio value={item.settingField}>
                            {translation("customerSettings." + item.time)}
                          </Radio>
                        </div>
                      </div>
                    ))}

                    <div className="row">
                      <div className="col-12">
                        <Radio value="other">
                          {translation("customerSettings.other")}
                        </Radio>
                      </div>
                    </div>
                  </Radio.Group>
                  <div className="d-flex align-items-center mt-2 mb-4">
                    <div style={{ width: 100, marginRight: 10 }}>
                      <InputNumber
                        disabled={
                          selectedTime !== "other" ||
                          settings.enableAutoSentNotiBeforeOtherDays === 0
                        }
                        value={settings.enableAutoSentNotiBeforeOtherDays}
                        min={1}
                        precision={0}
                        onChange={(value) => {
                          if (value === null) {
                            setIsHaveSelectedTime(false);
                          }
                          else{
                            setIsHaveSelectedTime(true);
                          }
                          const newSettings = { ...settings };
                          newSettings.enableAutoSentNotiBeforeOtherDays = value;
                          setSettings(newSettings);
                        }}
                        placeholder={translation("customerSettings.inputDays")}
                        className="customerSettings-dayInput"
                      />
                    </div>
                    <div className="customerSettings-day">
                      {translation("customerSettings.date")} :{" "}
                      {moment()
                        .add(settings.enableAutoSentNotiBeforeOtherDays, "days")
                        .format("DD/MM/YYYY")}
                    </div>
                  </div>
                </div>
                <div className="col-md-8 col-12">
                  <div className="d-md-none col-12 d-flex mb-2">
                    {translation("customerSettings.notificationType")}
                  </div>
                  {data.map((item, index) => {
                    return (
                      <div className="row">
                        <div className="col-md-6 col-12">
                          <div className="row" key={index}>
                            {item.notiField === "enableNotiBySMSRetry" ? (
                              <div
                                className="col-12 mb-0 mb-md-0"
                                style={{ minHeight: 32 }}
                              >
                                <Checkbox
                                  checked={
                                    settings[item.notiField] ===
                                    SETTING_STATUS.ENABLE
                                  }
                                  disabled={!settings.enableNotiByZaloCSKH}
                                  onChange={(e) => {
                                    if (!e.target.checked) {
                                      handleChangeTemplate(null, item.type);
                                    }
                                    handleCheckboxChange(item.notiField);
                                  }}
                                >
                                  {translation(
                                    "customerSettings." + item.notification
                                  )}
                                </Checkbox>
                              </div>
                            ) : (
                              <div
                                className="col-12 mb-0 mb-md-0"
                                style={{ minHeight: 32 }}
                              >
                                <Checkbox
                                  checked={
                                    settings[item.notiField] ===
                                    SETTING_STATUS.ENABLE
                                  }
                                  disabled={days.every((item) => !item)}
                                  onChange={(e) => {
                                    if (!e.target.checked) {
                                      handleChangeTemplate(null, item.type);
                                    }
                                    handleCheckboxChange(item.notiField);
                                  }}
                                >
                                  {translation(
                                    "customerSettings." + item.notification
                                  )}
                                </Checkbox>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="col-md-6 col-12">
                          <div className="row" key={index}>
                            <div className="col-12 mb-4" style={{ height: 32 }}>
                              <Select
                                placeholder={translation(
                                  "customerSettings.chooseTemplateMessage"
                                )}
                                style={{ width: "100%" }}
                                value={
                                  !settings[item.notiField]
                                    ? undefined
                                    : settings[item.type]
                                }
                                onChange={(value) =>
                                  handleChangeTemplate(value, item.type)
                                }
                                disabled={
                                  days.every((item) => !item) ||
                                  !settings[item.notiField]
                                }
                              >
                                {temps
                                  ?.filter(
                                    (i) =>
                                      i.messageTemplateType ===
                                      item.messageTemplateType
                                  )
                                  ?.map((item) => (
                                    <Option value={item.messageTemplateId}>
                                      {item.messageTemplateName}
                                    </Option>
                                  ))}
                              </Select>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  <div className="">
                    <Form
                      form={form}
                      name="confirmConfigTemplateName"
                      autoComplete="off"
                      onFinish={onFinish}
                      size="small"
                      colon={false}
                      labelAlign="right"
                    >
                      <Form.Item
                        name="enableAutoNotiSchedule"
                        valuePropName="checked"
                      >
                        <Checkbox disabled={!isHaveSelectedTime}>
                          {translation(
                            "customerSettings.enableAutoNotiSchedule"
                          )}
                        </Checkbox>
                      </Form.Item>
                    </Form>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-end">
                <BasicButtonPrimary
                  onclick={() => form.submit()}
                  loading={isLoading}
                  text={translation("customerSettings.save")}
                />
              </div>
            </Space>
          )}
        </div>
      )}
    </Fragment>
  );
};

export default CustomerCreateSetting;
